import { Icon, IconButton, Spinner, } from 'native-base';
import React, { FunctionComponent } from 'react';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { checkIsValid, getDataFromIntegration } from '../../utils/itemCommonFunctions';
export const PopulateElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {
    const {
        itemsStore, element, integrationsStore, statusStore,checkAndSetPayload,
        errorList, setErrorList
    } = initializeElement(props);

    const [loadingOptions, setLoadingOptions] = React.useState<boolean>(false);

    const getInfo = async () => {
        if(!canGetInfo()){
            return;
        }
        if (element.templateData?.closeRecord){
            statusStore.setStatus("pending");
        }
        setLoadingOptions(true);
        console.log("PopulateElement","getInfo");
        let data = await getDataFromIntegration(element, itemsStore.getPayloadElement, props.parentId,props.recordIdx, integrationsStore.getIntegration);
        itemsStore.populatePayload(data, element.integration.populateValues, props.parentId);
        
        setTimeout(() => {
            statusStore.reloadPayloadElementFromPopulate(data, element.integration.populateValues, props.parentId);
            setLoadingOptions(false);
            checkAndSetPayload(true);
            statusStore.setStatus("done");
        }, 400);

    }

    const canGetInfo = () => {
            if (element.templateData?.closeRecord) {   
                
                const form = itemsStore.getFormActive()                        
                let isvalid: boolean = checkIsValid(itemsStore, form, [element.id]);
                if(!isvalid)
                    statusStore.setFlashMessage("Debes completar todos los campos obligatorios antes de obtener la información")
                return isvalid;
            } else
                return true;
        }

    let btnCallIntegration = loadingOptions ? <Spinner key={"populate".concat(element.id, "Spinner")} size="lg" /> : <></>;
    if (!props.forReview && !loadingOptions && element.integration && element.integration.id)
        btnCallIntegration = <IconButton key="btnImportIntegration" size="lg" onPress={getInfo}  icon={<Icon as={MaterialCommunityIcons} name="cloud-search" size="lg" />} />;

    return <ElementBase errors={errorList} element={element} rightButton={btnCallIntegration} forReview={props.forReview} >
    </ElementBase>
}